import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Terms.css";
import LoginModal from "./LoginModal";
import logoApp from "../assets/logo-app.png";
import iconMail from "../assets/icon-mail.svg";
import iconThreads from "../assets/icon-threads.svg";
import iconFacebook from "../assets/icon-facebook.svg";
import iconInstagram from "../assets/icon-instagram.svg";

const Terms = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <div className="terms-page">
      {/* Navigation Bar */}
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="nav-brand">
            <img src={logoApp} alt="Runstreak Dashboard" className="nav-logo" />
            <span className="nav-brand-text">Runstreak Dashboard</span>
          </div>
          <div className="nav-menu">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/pricing" className="nav-link">Pricing</Link>
            <Link to="/help" className="nav-link">Help</Link>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-outlined">Login</button>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-primary">Get Started</button>
          </div>
        </div>
      </nav>

      {/* Login Modal */}
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />

      <div className="terms-container">
        <div className="terms-header">
          <h1>Terms of Service</h1>
          <p className="terms-subtitle">
            Last updated: January 2025
          </p>
        </div>

        <section className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Runstreak Dashboard ("Service"), you accept and
            agree to be bound by the terms and provision of this agreement. If you
            do not agree to these Terms of Service, please do not use our Service.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Description of Service</h2>
          <p>
            Runstreak Dashboard is a free running streak tracking platform that
            allows users to:
          </p>
          <ul>
            <li>Track running streaks and activities</li>
            <li>Sync data from Strava via OAuth integration</li>
            <li>Upload GPX/TCX files manually</li>
            <li>View analytics and performance metrics</li>
            <li>Connect with friends and compete on leaderboards</li>
            <li>Export activity data</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. User Accounts</h2>

          <h3>Account Creation</h3>
          <p>
            To use certain features of the Service, you must register for an
            account. You agree to:
          </p>
          <ul>
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain and update your information to keep it accurate</li>
            <li>Keep your password secure and confidential</li>
            <li>Notify us immediately of any unauthorized access to your account</li>
          </ul>

          <h3>Account Responsibility</h3>
          <p>
            You are responsible for all activities that occur under your account.
            You must be at least 13 years old to create an account.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any illegal or unauthorized purpose</li>
            <li>Violate any laws in your jurisdiction</li>
            <li>Upload false, misleading, or fraudulent activity data</li>
            <li>Harass, abuse, or harm other users</li>
            <li>Attempt to gain unauthorized access to the Service or other user accounts</li>
            <li>Interfere with or disrupt the Service or servers</li>
            <li>Use automated scripts or bots to access the Service</li>
            <li>Reverse engineer or attempt to extract source code</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. User Content</h2>

          <h3>Your Data</h3>
          <p>
            You retain ownership of all data and content you upload to the Service,
            including activity files and profile information.
          </p>

          <h3>License to Use</h3>
          <p>
            By uploading content to the Service, you grant us a non-exclusive,
            worldwide, royalty-free license to use, store, and display your content
            solely for the purpose of providing and improving the Service.
          </p>

          <h3>Data Accuracy</h3>
          <p>
            You are responsible for the accuracy of the data you provide. We are
            not responsible for any errors in synced or uploaded activity data.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Strava Integration</h2>
          <p>
            Our Strava integration uses OAuth authentication and is subject to:
          </p>
          <ul>
            <li>Strava's Terms of Service</li>
            <li>Strava's API Agreement</li>
            <li>Your Strava account settings and permissions</li>
          </ul>
          <p>
            You can disconnect your Strava account at any time. We are not
            responsible for any changes, interruptions, or discontinuation of
            Strava's API or services.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Service Availability</h2>
          <p>
            While we strive to provide continuous service, we do not guarantee that:
          </p>
          <ul>
            <li>The Service will be uninterrupted or error-free</li>
            <li>Defects will be corrected</li>
            <li>The Service is free of viruses or harmful components</li>
          </ul>
          <p>
            We reserve the right to modify, suspend, or discontinue the Service at
            any time without notice.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Data Backup and Loss</h2>
          <p>
            While we implement regular backups and security measures, we are not
            responsible for any loss of data. We strongly recommend that you:
          </p>
          <ul>
            <li>Keep copies of your original activity files</li>
            <li>Regularly export your data using our CSV export feature</li>
            <li>Maintain backups of important information</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>9. Privacy</h2>
          <p>
            Your use of the Service is also governed by our Privacy Policy. Please
            review our Privacy Policy to understand how we collect, use, and protect
            your information.
          </p>
        </section>

        <section className="terms-section">
          <h2>10. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are
            owned by Runstreak Dashboard and are protected by international
            copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section className="terms-section">
          <h2>11. Disclaimer of Warranties</h2>
          <p>
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES
            OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
            IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
            AND NON-INFRINGEMENT.
          </p>
        </section>

        <section className="terms-section">
          <h2>12. Limitation of Liability</h2>
          <p>
            IN NO EVENT SHALL RUNSTREAK DASHBOARD BE LIABLE FOR ANY INDIRECT,
            INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING
            WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, OR OTHER INTANGIBLE
            LOSSES, RESULTING FROM:
          </p>
          <ul>
            <li>Your use or inability to use the Service</li>
            <li>Any unauthorized access to or use of our servers and/or any personal information stored therein</li>
            <li>Any interruption or cessation of transmission to or from the Service</li>
            <li>Any bugs, viruses, or other harmful code</li>
            <li>Any errors or omissions in any content</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>13. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Runstreak Dashboard from any
            claims, damages, losses, liabilities, and expenses (including legal
            fees) arising out of your use of the Service or violation of these Terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>14. Termination</h2>
          <p>
            We may terminate or suspend your account and access to the Service
            immediately, without prior notice or liability, for any reason,
            including breach of these Terms.
          </p>
          <p>
            You may terminate your account at any time by deleting it from your
            profile settings. Upon termination, all data associated with your
            account will be permanently deleted.
          </p>
        </section>

        <section className="terms-section">
          <h2>15. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify
            users of any material changes by posting the new Terms on this page and
            updating the "Last updated" date.
          </p>
          <p>
            Your continued use of the Service after changes constitutes acceptance
            of the new Terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>16. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with
            applicable laws, without regard to conflict of law provisions.
          </p>
        </section>

        <section className="terms-section">
          <h2>17. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact
            us:
          </p>
          <p>
            <a href="mailto:hello@runstreakdashboard.com">
              hello@runstreakdashboard.com
            </a>
          </p>
        </section>

        <section className="terms-section">
          <h2>18. Severability</h2>
          <p>
            If any provision of these Terms is found to be unenforceable or invalid,
            that provision will be limited or eliminated to the minimum extent
            necessary, and the remaining provisions will remain in full force and
            effect.
          </p>
        </section>

        <section className="terms-section">
          <h2>19. Entire Agreement</h2>
          <p>
            These Terms constitute the entire agreement between you and Runstreak
            Dashboard regarding the use of the Service, superseding any prior
            agreements.
          </p>
        </section>
      </div>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-brand">
              <img src={logoApp} alt="Runstreak Dashboard" className="brand-logo" />
              <span>Runstreak Dashboard</span>
            </div>
            <p>Keep your running streak alive with the most motivational fitness app.</p>
            <div className="social-links">
              <a href="#threads"><img src={iconThreads} alt="Threads" /></a>
              <a href="#facebook"><img src={iconFacebook} alt="Facebook" /></a>
              <a href="#instagram"><img src={iconInstagram} alt="Instagram" /></a>
            </div>
          </div>

          <div className="footer-column">
            <h4>Product</h4>
            <ul>
              <li><a href="/#features">Features</a></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><a href="#download">Download</a></li>
              <li><a href="#updates">Updates</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li><Link to="/help">Help Center</Link></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Contact Us</a></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Bug Reports</a></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Feature Requests</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Careers</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>© 2025 Runstreak. All rights reserved.</p>
          <div className="footer-contact">
            <img src={iconMail} alt="" />
            <a href="mailto:hello@runstreakdashboard.com">hello@runstreakdashboard.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;
